















import { Mixins, Component } from "vue-property-decorator";
import Context from "@/mixins/context";
@Component
export default class SessionChangedModal extends Mixins(Context) {
  private isProcessing = false;
  public get hasSession() {
    // Get access_token from localStorage, NOT store as it may have changed in another window
    return !!localStorage.getItem(`${this.context}/auth/token/access_token`);
  }
  public get translateKey() {
    return this.hasSession ? "session_changed" : "session_ended";
  }
  public get actionKey() {
    return this.hasSession ? "reload_page" : "return_to_login";
  }
  // Methods
  private onSubmit() {
    this.isProcessing = true;
    if (this.hasSession) {
      window.location.reload();
    } else {
      this.$emit("close");
      this.$store.commit(`auth/${this.context}/reset`);
      this.$router
        .replace({ name: `${this.context}Logout` })
        .catch((this.$router as any).handleFailure);
    }
  }
}
